/** Color along the destructive → success hue ramp; 0 is destructive, 1 success. */
export function gradeScaleColorAt(position: number): string {
  const clamped: number = Math.min(Math.max(position, 0), 1);
  return `color-mix(in hsl, var(--color-destructive), var(--color-success) ${Math.round(clamped * 100)}%)`;
}

/** Evenly spaced ramp colors for a scale with `count` grade bands. */
export function gradeScalePalette(count: number): string[] {
  if (count <= 1) {
    return [gradeScaleColorAt(0)];
  }
  return Array.from({ length: count }, (_, index) => gradeScaleColorAt(index / (count - 1)));
}
